import React from "react";
import "../Video/video-react.scss";
import { 
    // calculateWidthAndHeight,
    millisToMinutesAndSeconds } from "../../../../Helpers/Utility";
import VideoPlayer from "../../Conversation/VideoPlayer";
import { ChatAudioSender2Hoc } from "../../../../assets/images";

const PreviewAudio = (props = {}) => {
  const CAPTION_MARGIN = 0;
  const { media } = props;
  const [getPreviewVideo, setPreviewVideo] = React.useState({
    originalWidth: 0,
    originalHeight: 0,
    uniqueId: Date.now(),
    videoSrc: URL.createObjectURL(props.media),
    duration:0
  });

  const { uniqueId } = getPreviewVideo;

  const setFileInfo = (file) => {
    const fileReader = new FileReader();
    fileReader.onload = () => {
      const blob = new Blob([fileReader.result], { type: file.type });
      const url = URL.createObjectURL(blob);
      const video = document.createElement("audio");
      video.addEventListener("error", (ex) => {
        console.log("error when loading video file", ex);
      });
      video.addEventListener("loadeddata", () => {
        /**
        // const canvas = document.createElement("canvas");
        */
        setPreviewVideo({
          ...getPreviewVideo,
          originalWidth: video.videoWidth,
          originalHeight: video.videoHeight,
        });
        /**
        // const { webWidth, webHeight, androidWidth, androidHeight } =
        //   calculateWidthAndHeight(video.videoWidth, video.videoHeight);
        // const width = video.videoWidth;
        // const height = video.videoHeight;
        // canvas.width = MIN_THUMB_WIDTH;
        // canvas.height = (height / width) * MIN_THUMB_WIDTH;
        // canvas
        //   .getContext("2d")
        //   .drawImage(
        //     video,
        //     0,
        //     0,
        //     MIN_THUMB_WIDTH,
        //     (height / width) * MIN_THUMB_WIDTH
        //   );
        // const image = canvas.toDataURL();
        // const thumb = image.replace(/^data:image\/\w+;base64,/, "");
        */
        props.updateMedia(props.media, {
          duration: Math.round(video.duration * 1000),
          imageUrl: video.src,
          msgType: "audio",
          audioType:"file"
        });
        URL.revokeObjectURL(url);
        setPreviewVideo({...getPreviewVideo, duration:Math.round(video.duration * 1000)})
      });
      video.preload = "metadata";
      video.src = url;
      video.muted = true;
      video.play();
    };
    fileReader.readAsArrayBuffer(file);
  };

  React.useEffect(() => {
    setFileInfo(props.media);
    return () => {
      URL.revokeObjectURL(media.fileDetails.imageUrl);
    };
  }, []);

  return (
    <React.Fragment>
      <div className="type-media video">
        <div className="video-wrapper-0" id="video-wrapper-0">
          {(
            <div className="video-wrapper1" id={`video-player-${uniqueId}`}>
              <i className={`AudioDetails ${"default"}`}>
                  <ChatAudioSender2Hoc />{" "}
                  <span className="audioDuration">{millisToMinutesAndSeconds(getPreviewVideo.duration)}</span>
              </i>
              <VideoPlayer
              //   webWidth={getPreviewVideo.originalWidth}
              //   webHeight={getPreviewVideo.originalHeight}
                captionMargin={CAPTION_MARGIN}
                fileType={"audio"}
                url={getPreviewVideo.videoSrc}
                audioDuration={millisToMinutesAndSeconds(getPreviewVideo.duration)}
              />
            </div>
          )}
        </div>
        {/* <Caption
          onChangeCaption={props.onChangeCaption}
          media={props.media}
          onClickSend={props.onClickSend}
          uniqueId={uniqueId}
        /> */}
      </div>
    </React.Fragment>
  );
};

export default PreviewAudio;
